<script>
import FormGroup from '@/pages/components/form/horizontal/form-group.vue'
import formInput from "@wielink-application/shared/js/mixins/formInput";
import Phone from "@/pages/components/form/input-only/phone.vue";

export default {
  mixins: [formInput],
  components: {FormGroup, Phone},
  props: {
    'groupClasses': {
      type: String,
      required: false
    },
    'label': {
      type: String,
      required: false
    }
  }
}
</script>

<template>
  <FormGroup :group-classes="groupClasses" :has-error="hasError" :id="renderedId">
    <template #label>{{ label }}</template>

    <Phone
        v-bind="$attrs"
        :form="form"
        :name="name"
        :id="renderedId"
        :model-value="modelValue"
        @update:modelValue="changeModelValueTo"
    />
  </FormGroup>
</template>